<div class="container py-5">
  <h1 class="main-title text-center mb-4 text-uppercase fw-bold">
    {{ config.catalogueHeaderText || 'CATALOGUE SHOWCASE' }}
  </h1>

  <p-carousel [value]="config.catalogueSliderImageUrls" [numVisible]="3" [numScroll]="1" [circular]="true"
    [showIndicators]="false" [showNavigators]="true" [autoplayInterval]="1500" [responsiveOptions]="responsiveOptions"
    styleClass="custom-carousel" dir="ltr">
    <ng-template pTemplate="item" let-image>
      <div class="carousel-item-wrapper">
        <img [src]="imageUrl + image" alt="Catalogue Page" class="carousel-image" />
      </div>
    </ng-template>
  </p-carousel>
</div>
